// extracted by mini-css-extract-plugin
export default {"AssignDiscipline":"AssignDiscipline_AssignDiscipline__5ZKxc","modalBody":"AssignDiscipline_modalBody__J0Z-V","list":"AssignDiscipline_list__KP4Vc"};